import $ from 'jquery';
import 'bootstrap';
import 'slick-carousel';
import './modules/burger-rotate.js';
import './modules/carousels.js';
import './modules/symptom-checker.js';
import './modules/nav-menu.js';
import './modules/sticky-header.js';

$('.dropdown > a').click(function(){

    if(!$(this).hasClass('show')) {
        location.href = this.href;
    }

});
